module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Toolbar"
  }, [_c('div', {
    staticClass: "Toolbar-wrapper"
  }, [_c('div', {
    staticClass: "Toolbar-pageControls"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.prevPage()
      }
    }
  }, [_c('span', {
    staticClass: "hidden-xs hidden-sm"
  }, [_vm._v("Prev")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_c('span', {
    staticClass: "hidden-xs hidden-sm"
  }, [_vm._v("Next")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showInks()
      }
    }
  }, [_vm._v("Inks")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showOverview()
      }
    }
  }, [_vm._v("Overview")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showOverprint()
      }
    }
  }, [_vm._v("Overprint")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleBoxes()
      }
    }
  }, [_vm._v("Boxes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleRulers()
      }
    }
  }, [_vm._v("Rulers")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setUnits('mm')
      }
    }
  }, [_vm._v("mm")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setUnits('inch')
      }
    }
  }, [_vm._v("inch")])])])]), _vm._v(" "), _c('div', {
    staticClass: "Toolbar-zoomControls"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.zoomIn()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zoomLevel),
      expression: "zoomLevel"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.zoomLevel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zoomLevel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.zoomOut()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.fitTo('page')
      }
    }
  }, [_vm._v("Fit to page")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.fitTo('width')
      }
    }
  }, [_vm._v("Fit to width")])])]), _vm._v(" "), _c('div', {
    staticClass: "Toolbar-mobileToggle"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleMobileToggleBtnClick
    }
  }, [(!_vm.isMobileAdvancedMenuOpen) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _vm._e(), _vm._v(" "), (_vm.isMobileAdvancedMenuOpen) ? _c('i', {
    staticClass: "fa fa-times"
  }) : _vm._e()])])]), _vm._v(" "), (_vm.isMobileAdvancedMenuOpen) ? _c('div', {
    staticClass: "Toolbar-mobileAdvanced"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showInks()
      }
    }
  }, [_vm._v("Inks")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showOverview()
      }
    }
  }, [_vm._v("Overview")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setUnits('mm')
      }
    }
  }, [_vm._v("mm")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setUnits('inch')
      }
    }
  }, [_vm._v("inch")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "visible-xs visible-sm"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "visible-xs visible-sm"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4039a597"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toolbar.vue
// module id = 421
// module chunks = 1